import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import DashboardStatsService from "./dashboardStatsService";



// Define initial state
const initialState = {
  dashboardStatsDetails: [],
  dashboardStatsId: "",
  isLoading: false,
  isSuccess: false,
  isError: false,
  message: "",

  isdashboardStatsLoading: false,
  isdashboardStatsLoadingError: false,
};



export const getDashboardStatsData = createAsyncThunk(
  "dashboardStats/getDashboardStatsData",
  async (clinicId: any, thunkAPI) => {
    try {
      const response = await DashboardStatsService.getDashboardStats(clinicId);
      return response.data;
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);


export const dashboardStatsSlice = createSlice({
  name: "dashboardStatsSlice",
  initialState,
  reducers: {
    reset: () => initialState,
    changeDashboardStatsId: (state, action) => {
      state.dashboardStatsId = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getDashboardStatsData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDashboardStatsData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.dashboardStatsDetails = action.payload;
        state.message = "";
      })
      .addCase(getDashboardStatsData.rejected, (state:any, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

// Export actions and reducer
export const { reset, changeDashboardStatsId } = dashboardStatsSlice.actions;
export default dashboardStatsSlice.reducer;
